import React, { Component } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';


class DateRangeLink extends Component {
    render() {
        const { dateRangeString, children, title, target, to } = this.props;
        const dateAppend = dateRangeString || '';
        return <Link to={`${to}${dateAppend}`} title={`${title}`} target={target} >{children}</Link>;
    }
}

DateRangeLink.propTypes = {
    selectedTimeRangeKey: PropTypes.string.isRequired,
    dateRangeString: PropTypes.string.isRequired,
    children: PropTypes.string.isRequired,
    title: PropTypes.string.isRequired,
    target: PropTypes.string,
    to: PropTypes.string.isRequired
};

const mapStateToProps = state => ({
    selectedTimeRangeKey: state.config.selectedTimeRange.key,
    dateRangeString: state.router.location.search
});

export default connect(mapStateToProps)(DateRangeLink);




// WEBPACK FOOTER //
// ./src/containers/buttons/DateRangeLink.js